import styled from 'styled-components';

import { rem } from '../../utils/index';

export const StyledButtonsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => `${rem(theme.Spacing.Size.Small)}`};
`;
